import { ReactNode } from 'react';

import { styled } from '@mui/material';

import { Box } from '../../../Box';

export type SidebarProps = {
  children: ReactNode;
};

const StyledSidebar = styled(Box)({
  backgroundColor: 'var(--color-neutral-200)',
  borderRight: '1px solid var(--color-neutral-300)',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  alignItems: 'flex-start',
  padding: 12,
});

export const Sidebar = ({ children }: SidebarProps) => {
  return <StyledSidebar>{children}</StyledSidebar>;
};
